module.exports = __webpack_public_path__ + "static/media/28DGC9.4c9830de.jpg";